export const modalsTranslations = {
  pt: {
    planLimit: {
      title: "Atualize seu plano",
      description: "Você atingiu o limite de {pages} para seu plano {plan}. Faça upgrade para criar mais páginas.",
      pagesSingular: "página",
      pagesPlural: "páginas",
      processing: "Processando...",
      selectPlan: "Assinar agora",
      cancel: "Cancelar"
    },
    createShortLink: {
      title: "Criar Link Curto",
      targetUrl: "URL de destino *",
      targetUrlPlaceholder: "Digite o link de destino (ex: exemplo.com)",
      optionalTitle: "Título (opcional)",
      linkName: "Nome do link",
      creating: "Criando...",
      createLink: "Criar Link",
      cancel: "Cancelar",
      error: "Erro ao criar link curto: "
    }
  },
  en: {
    planLimit: {
      title: "Upgrade your plan",
      description: "You've reached the limit of {pages} for your {plan} plan. Upgrade to create more pages.",
      pagesSingular: "page",
      pagesPlural: "pages",
      processing: "Processing...",
      selectPlan: "Subscribe now",
      cancel: "Cancel"
    },
    createShortLink: {
      title: "Create Short Link",
      targetUrl: "Target URL *",
      targetUrlPlaceholder: "Enter the destination link (ex: example.com)",
      optionalTitle: "Title (optional)",
      linkName: "Link name",
      creating: "Creating...",
      createLink: "Create Link",
      cancel: "Cancel",
      error: "Error creating short link: "
    }
  }
};
